import { Button, Card, Col, Container, Row } from "react-bootstrap";
import CoursePlan from "../../docs/VEL710RevisedCourseOutline.pdf";
import Background from "../../image/background9.jpg";

export default function TraditionalKnowledge() {
    return(
        <>
        <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
        <Container>
            <Row className="justify-content-center section">
                <Col md="8" sm="12" className="image-over-section">
                    <h2 style={{textAlign:"center"}}>Traditional Knowledge and Values (VEL710)</h2>
                    <p style={{textAlign:"center"}}>The primary objective of the course is to introduce students to the social and cultural values inherent in Traditional Knowledge Systems (TKS) that are practised by communities. The course also endeavours to understand the contemporary significance of these values and knowledge systems for moving towards a harmonious and sustainable global world order.</p>
                    <Button href={CoursePlan} target="_blank">Course plan <i className="bi bi-box-arrow-up-right"></i></Button>
                </Col>
            </Row>
        </Container>
        </Container>

        <Container className="section">
                <h2>Course Structure</h2>
            <Row xs="1" sm="3" md="3">
                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 1 : COURSE INTRO</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>What constitutes Knowledge?</li>
                                    <li>Knowledge Quest & Framework of Traditional Knowledge</li>
                                    <li>Why is TK relevant?</li>
                                    <li>Educational Documentary Film 1</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 2 : TK THROUGH THE AGES</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Antiquity & Unique Aspects of TK</li>
                                    <li>Society and Polity in Pre-Industrial Times</li>
                                    <li>Introduction to Aanchalikta</li>
                                    <li>Educational Documentary Film 2</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 3 : VALUES IN TRADITION & MODERNITY</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Values Embodied in TK</li>
                                    <li>Values in Modern Techno-Economic Paradigm</li>
                                    <li>Reductionism & Holism, Individual & Collective</li>
                                    <li>Educational Documentary Film 3</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 4 : CUSTODIANS OF TK</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Knowledge of Land & Water : Kisan Vidya</li>
                                    <li>Knowledge of Metals & Materials : Karigar Vidya</li>
                                    <li>Knowledge of Forest Ecology : Adivasi Vidya</li>
                                    <li>Knowledge of Health & Well-Being : Swasthya Vidya</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 5 : VALUES IN COMMUNITIES</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Relating to Locality, Flora & Fauna</li>
                                    <li>Natural Abundance Frameworks in TK</li>
                                    <li>Aesthetics & Beauty in TK</li>
                                    <li>Educational Documentary Film 4</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 6 : TK IN FOOD & HEALTH</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Knowledge of the Seasons : Rtucharya</li>
                                    <li>Knowledge of the Human Constitution : Tridosha Theory</li>
                                    <li>Ayurveda, Unani & Local Health Traditions</li>
                                    <li>Educational Documentary Film 5</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 7 : TK & GANDHIAN METHOD</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Practising Empathy, Kindness and Compassion</li>
                                    <li>Deep Ecological Approaches</li>
                                    <li>Scientific Enquiry into Universal Values</li>
                                    <li>Educational Documentary Film 6</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 8 : CONTEMPORARY RELEVANCE OF TK</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Promoting Cultural Diversity</li>
                                    <li>Creating Ethical Livelihoods</li>
                                    <li>Healing the Planet</li>
                                    <li>Consciousness Elevation for Well-being</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 9 : SUMMARY & CONCLUSIONS</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Contemporary Challenges</li>
                                    <li>Creative & Innovative Possibilities</li>
                                    <li>Individual Capacities & Collective Responsibilities</li>
                                    <li>New Questions & Way Forward</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>
        </Container>
        </>
        )
    }